import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3579bab8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-countdown"
}
const _hoisted_2 = { class: "m-countdown-title" }
const _hoisted_3 = { class: "m-countdown-clock" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Days", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hours", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Minutes", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Seconds", -1))
const _hoisted_8 = {
  key: 1,
  class: "m-countdown-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.state.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.activeCountdown)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.countdownTypeText), 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _hoisted_4,
                  _createElementVNode("p", null, _toDisplayString(_ctx.countdown.days), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_5,
                  _createElementVNode("p", null, _toDisplayString(_ctx.countdown.hours), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_6,
                  _createElementVNode("p", null, _toDisplayString(_ctx.countdown.minutes), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createElementVNode("p", null, _toDisplayString(_ctx.countdown.seconds), 1)
                ])
              ])
            ], 64))
          : (_ctx.countdownTypeText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(_ctx.countdownTypeText), 1)
              ]))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}